<template>
    <el-container style="height: 100vh;">
  <el-aside width="150px" >
    <Menu />
  </el-aside>

  <el-container>
    <el-header style="text-align: right; font-size: 12px; background-color: #333333; color: white; height: 56px;">
      <!-- <el-dropdown>
        <i class="el-icon-setting" style="margin-right: 15px"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>查看</el-dropdown-item>
          <el-dropdown-item>新增</el-dropdown-item>
          <el-dropdown-item>删除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <el-image v-if="userInfo"
      style="width: 30px; height: 30px; border: #b9b9b9 1px solid; border-radius: 5px;vertical-align:middle; margin-right: 10px;"
      :src="userInfo.figure" />
      <span v-if="userInfo" style="font-size:16px;">{{userInfo.name}}  （ {{userInfo.coin}} ）</span>
    </el-header>

    <el-main>
        <router-view/>
        <Footer />
    </el-main>
  </el-container>
</el-container>
</template>

<script>
    import { MyStorage } from '@/common.js';
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'home',
  components: {
    Menu,Footer
  },
  data(){
      return {
          userInfo:null,
      }
  },
  mounted() {
    console.log(JSON.parse(MyStorage.getItem("userInfo")));
    if (MyStorage.getItem("userInfo")) {
      this.userInfo=JSON.parse(MyStorage.getItem("userInfo"))
    }
  },
}
</script>

<style>
     .el-header {
        background-color: #B3C0D1;
        color: #333;
        line-height: 60px;
      }

      .el-aside {
        color: #333;
      }


body{
  margin: 0;
}
#main{
  padding: 50px;
}
.text-center{
  text-align: center;
}
.w100{
  width: 100%;
}
.w1200px{
  max-width: 1200px;
  margin: auto;
}

.el-table{
  margin-top: 20px;
}
</style>
